import { REACT_APP_PERITADOR_API } from '../../config'
import axios from 'axios'

export async function getTabs(args) {
    const response = await axios.get(
        `${REACT_APP_PERITADOR_API}/requests/getTabs${args.length > 0 ? '?search=' + args + '' : ''}`,
      ) 
  return response.data?.request?.tabs
}